import { Container, StyledParagraph } from "../styled";

export default () => (
    <Container>
        <StyledParagraph>
            Wspólną działalność projektową prowadzimy od 2011, a przyjaźnimy się od kilkunastu lat,
            mamy wieloletnie doświadczenie pracy w najbardziej renomowanych warszawskich pracowniach.
            <br />
            Wszyscy wspólnicy posiadają uprawnienia budowlane w specjalności architektonicznej 
            do projektowania bez ograniczeń oraz są czynnymi członkami 
            Izby Architektów Rzeczypospolitej Polskiej.
        </StyledParagraph>
        <StyledParagraph>
            wspólnicy:
            <br />
            Magda Tylman – architekt, członek MOIA
            <br />
            Łukasz Racinowski – architekt, członek MOIA
        </StyledParagraph>
        <StyledParagraph>
            zespół projektowy:
            <br />
            Mateusz Bednarz – architekt
        </StyledParagraph>
        <StyledParagraph>
            <em>byli współpracownicy:</em>
            <br />
            <em>Tomasz Urbański – architekt, członek MOIA – wspólnik w latach 2011-2021</em>
        </StyledParagraph>
        <StyledParagraph>
            <em>Magdalena Chrzanowska – architekt</em>
            <br />
            <em>Beata Murawska – architekt</em>
        </StyledParagraph>     
    </Container>
);